module.exports = __webpack_public_path__ + "static/media/playspace_section1.d29c08a3.png";